import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import NumberBox, { Format } from "devextreme-react/number-box";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarImovelDs,
  criarContribuinteDs,
  criarLogradouroDs,
  criarBairroDs,
  criarDistritoDs,
  criarSegmentosDs,
  criarLoteamentoDs,
  criarMotivoIsencaoIptuDs,
  criarCpbsDs,
  criarColaboradorDs,
} from "../../DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import "./imovel.scss";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { TextBox, ScrollView } from "devextreme-react";
import LogradourosBox from "../LogradourosBox";
import ImovelButtonGroup from "./imovelButtonGroup";
import axiosApi from "../../api-axios";
import Memoria from "../../Memoria";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";
import { LoadIndicator } from "devextreme-react/load-indicator";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  contribuinteId: null,
  distritoCartografia: undefined,
  setorCartografia: undefined,
  quadraCartografia: undefined,
  loteCartografia: undefined,
  unidadeCartografia: undefined,
  imovelAnteiorId: undefined,
  natureza: 1,
  situacao: 1,
  cep: "",
  logradouroId: null,
  numero: undefined,
  segmentoId: "",
  complemento: undefined,
  bairroId: undefined,
  distritoId: undefined,
  loteamentoId: undefined,
  loteLoteamento: undefined,
  quadraLoteamento: undefined,
  larguraLote: undefined,
  comprimentoLote: undefined,
  areaLote: undefined,
  larguraEdificacao: undefined,
  comprimentoEdificacao: undefined,
  areaEdificacao: undefined,
  numeroPavimentos: undefined,
  numeroUnidades: undefined,
  numeroFrentes: undefined,
  areaPrivada: undefined,
  areaComum: undefined,
  posicaoFiscalIptu: 0,
  posicaoFiscalTsu: 0,
  patrimonio: 1,
  posicaoPatrimonial: 1,
  uso: 0,
  coordenadaX: undefined,
  coordenadaY: undefined,
  cozinhas: undefined,
  quartos: undefined,
  salas: undefined,
  wc: undefined,
  afastamentoFrontal: undefined,
  larguraPasseio: undefined,
  qtdeArvoresPasseio: undefined,
  setorCensitario: null,
  anoConstrucao: undefined,
  inscricaoCAA: undefined,
  inscricaoCAE: undefined,
  qtdePontosDeAgua: undefined,
  SituacaoProcessoJudicial: 1,
  dataProcesso: undefined,
  processo: undefined,
  cartorioId: undefined,
  matricula: undefined,
  testada2: undefined,
  logradouroTestada2Id: undefined,
  testada3: undefined,
  logradouroTestada3Id: undefined,
  testada4: undefined,
  logradouroTestada4Id: undefined,
  observacao: undefined,
  motivoInativacao: undefined,
  dataInativacao: undefined,
  exibirPesquisaContribuinte: false,
  loadIndicatorVisivel: false,
  textoBotao: "Salvar",
  exibirPesquisaLogradouro: false,

  _uiConfirmarDiatEIptu: false,
  _uiContribuinteIdOriginal: undefined,
  atualizarDiatImovel: false,
  atualizarIptuExercicio: false,
  exercicioDiatInicial: 0

};

export default class ImovelForm extends React.Component {
  constructor(props) {
    super(props);
    this.formImovel = React.createRef();
    this.imovelDs = criarImovelDs();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    template.digitadorId = UserInfo.getUsuarioId();
    this.state = { ...(_cadastroCorrente || template), _uiCarregando: true };
    this.obterStatePorImovel = this.obterStatePorImovel.bind(this);
    this.showDadosInativacao = this.showDadosInativacao.bind(this);
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.logradourosBoxRef = React.createRef();
    this.contribuinteBoxRef = React.createRef();
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
    this.onValueChanged = this.onValueChanged.bind(this);
    this.situacaoChange = this.situacaoChange.bind(this);

    this.cpbsOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: " ",
      dataSource: criarCpbsDs(),
      valueExpr: "id",
      displayExpr: "contribuinte.nome",
      showCloseButton: true,
      showClearButton: true,
    };

    this.logradourosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: " ",
      dataSource: criarLogradouroDs(),
      valueExpr: "id",
      displayExpr: "nome",
      showClearButton: true,
    };

    this.bairrosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: criarBairroDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.distritosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: criarDistritoDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.segmentosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: criarSegmentosDs(),
      valueExpr: "id",
      displayExpr: "codigo",
    };
    this.loteamentosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: " ",
      dataSource: criarLoteamentoDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.motivoIsensaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: criarMotivoIsencaoIptuDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.colaboradorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      dataSource: criarColaboradorDs(),
      valueExpr: "id",
      displayExpr: "nome",
    };

    this.escolherNatureza = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: [
        { id: 0, descricao: "EDIFICADO" },
        { id: 1, descricao: "TERRITORIAL" },
        { id: 2, descricao: "GLEBA TERRITORIAL" },
        { id: 3, descricao: "EM CONSTRUCAO" },
        { id: 4, descricao: "RESIDENCIAL" },
        { id: 5, descricao: "COMERCIAL/SERVIÇOS" },
        { id: 6, descricao: "GALPÃO/TELHEIRO" },
        { id: 7, descricao: "INDUSTRIAL" },
        { id: 8, descricao: "GLEBA EDIFICADA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.escolherTipoPatrimonio = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: [
        { id: 1, descricao: "PARTICULAR" },
        { id: 2, descricao: "MUNICIPAL" },
        { id: 3, descricao: "ESTADUAL" },
        { id: 4, descricao: "FEDERAL" },
        { id: 5, descricao: "RELIGIOSO" },
        { id: 6, descricao: "PARTIDO POLÍTICO" },
        { id: 7, descricao: "SOCIEDADE CIVIL" },
        { id: 8, descricao: "SINDICATO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.escolherPosicaoFiscal = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: [
        { id: 0, descricao: "TRIBUTÁVEL" },
        { id: 1, descricao: "IMUNE" },
        { id: 2, descricao: "ISENTO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.escolherPosicaoPatrimonial = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: [
        { id: 1, descricao: "PRÓPRIA" },
        { id: 2, descricao: "POSSE" },
        { id: 3, descricao: "INVASÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.escolherUsoImovel = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: [
        { id: 0, descricao: "NÃO INFORMADO" },
        { id: 1, descricao: "ALUGADO / CEDIDO" },
        { id: 2, descricao: "PRÓPRIO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.escolherSituacaoProcessoJudicial = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: [
        { id: 1, descricao: "NÃO" },
        { id: 2, descricao: "SIM" },
        { id: 3, descricao: "ENCERRADO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.naturezaOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "TERRITORIAL" },
        { id: 0, descricao: "PREDIAL" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.situacaoOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "ATIVO" },
        { id: 2, descricao: "INATIVO" },
      ],
      onValueChanged: this.situacaoChange,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.simNaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.renderCartografia = this.renderCartografia.bind(this);
    this.setCartDistrito = this.setCartDistrito.bind(this);
    this.setCartSetor = this.setCartSetor.bind(this);
    this.setCartQuadra = this.setCartQuadra.bind(this);
    this.setCartFace = this.setCartFace.bind(this);
    this.setCartLote = this.setCartLote.bind(this);
    this.setCartUnidade = this.setCartUnidade.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
    this.onLogradouroSelecionadoPesq =
      this.onLogradouroSelecionadoPesq.bind(this);
    this.onLogradouroChange = this.onLogradouroChange.bind(this);

    this.okConfirmar = this.okConfirmar.bind(this);
  }

  onLogradouroSelecionadoPesq(e) {
    let data = {
      value: e.row.data.sequencial,
    };
    this.onLogradouroChange(data);
  }

  onLogradouroChange(e) {
    criarLogradouroDs()
      .load({ filter: ["sequencial", "=", e.value] })
      .then((response) => {
        if (
          response !== null &&
          response !== undefined &&
          response.length > 0
        ) {
          this.setState(
            {
              logradouroId: e.value,
              _uiLogradouroNome: response[0].nomeCompleto,
              exibirPesquisaLogradouro: false,
            },
            () => {
              this.formImovel.current.instance.getEditor("numero").focus();
            }
          );
        } else {
          this.setState({
            logradouroId: "",
            _uiLogradouroNome: "LOGRADOURO NÃO ENCONTRADO",
            exibirPesquisaLogradouro: false,
          });
        }
      });
  }

  situacaoChange(e) {
    this.setState({
      Situacao: e.value,
      dataInativacao: new Date(),
    });
  }

  //Componente pesquisar contribuinte
  setContribuinteId(data) {
    this.setState({ contribuinteId: data });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: ["sequencial", "=", this.state.contribuinteId] })
      .then((result) => {
        if (result[0] === undefined) {
          this.setState({
            _uiNomeContribuinte: "",
            _uiDocumentoContribuinte: "",
          });
        } else {
          this.setState({
            _uiNomeContribuinte: result[0].nome,
            _uiDocumentoContribuinte: result[0].documentoFormatado,
          });
        }
      })
      .catch((_) => {
        this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
      });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      exibirPesquisaContribuinte: false,
    });
    this.atualizarNomeContribuinte();
  }

  //Fim Pesquisar contribuinte

  obterStatePorImovel(data) {
    console.log("data imovel", data);
    const contribuinteId =
      data.contribuinte == undefined ? undefined : data.contribuinte.sequencial;
    const logradouroId =
      data.logradouro == undefined ? undefined : data.logradouro.sequencial;

    const estado = {
      id: data.id,
      sequencial: data.sequencial,
      prefeituraId: data.prefeituraId,
      contribuinteId: contribuinteId,
      distritoCartografia: data.distritoCartografia,
      setorCartografia: data.setorCartografia,
      quadraCartografia: data.quadraCartografia,
      faceCartografia: data.faceCartografia,
      loteCartografia: data.loteCartografia,
      unidadeCartografia: data.unidadeCartografia,
      imovelAnteiorId: data.imovelAnteriorId,
      imovelOriginalId: data.imovelOriginalId,
      natureza: data.natureza,
      situacao: data.inativo ? 2 : 1,
      cep: data.cep,
      logradouroId: logradouroId,
      numero: data.numero,
      segmentoId: data.codSegmento,
      complemento: data.complemento,
      bairroId: data.bairroId,
      distritoId: data.distritoId,
      loteamentoId: data.loteamentoId,
      loteLoteamento: data.lote,
      quadraLoteamento: data.quadra,
      larguraLote: data.testadaPrincipal,
      comprimentoLote: data.ladoEsquerdo,
      areaLote: data.areaLote,
      larguraEdificacao: data.frenteConstrucao,
      comprimentoEdificacao: data.ladoEsquerdoConstrucao,
      areaEdificacao: data.areaEdificada,
      numeroPavimentos: data.numeroDePavimentos,
      numeroUnidades: data.numeroDeUnidades,
      numeroFrentes: data.numeroDeFrentes,
      areaPrivada: data.areaPrivada,
      areaComum: data.areaComum,
      posicaoFiscalIptu: data.posicaoFiscalIptu,
      posicaoFiscalTsu: data.posicaoFiscalTsu,
      patrimonio: data.tipoDePatrimonio,
      posicaoPatrimonial: data.posicaoPatrimonial,
      uso: data.usoDoImovel,
      coordenadaX: data.coordenadaX,
      coordenadaY: data.coordenadaY,
      cozinhas: data.cozinhas,
      quartos: data.quartos,
      salas: data.salas,
      wc: data.wc,
      afastamentoFrontal: data.afastamentoFrontal,
      larguraPasseio: data.larguraPasseio,
      qtdeArvoresPasseio: data.qtdeArvoresPasseio,
      setorCensitario: data.setorCensitario,
      anoConstrucao: data.anoConstrucao,
      inscricaoCAA: data.inscricaoCAA,
      inscricaoCAE: data.inscricaoCAE,
      qtdePontosDeAgua: data.qtdePontosDeAgua,
      situacaoProcessoJudicial: data.situacaoProcessoJudicial,
      dataProcesso: data.dataProcesso,
      processo: data.processo,
      cartorioId: data.cartorioId,
      matricula: data.matricula,
      testada2: data.testada2,
      logradouroTestada2Id: data.logradouroTestada2Id,
      testada3: data.testada3,
      logradouroTestada3Id: data.logradouroTestada3Id,
      testada4: data.testada4,
      logradouroTestada4Id: data.logradouroTestada4Id,
      observacao: data.obs,
      _uiSalvando: false,
      _uiCarregando: false,

      _uiConfirmarDiatEIptu: false,
      _uiContribuinteIdOriginal: contribuinteId,
      atualizarDiatImovel: false,
      atualizarIptuExercicio: true,
      exercicioDiatInicial: 0
    };

    return estado;
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.imovelDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data === undefined) {
            notify("Imóvel não encontrado.", "error");
            this.props.history.push("/imoveis");
          }

          const estado = this.obterStatePorImovel(data);
          const nomeContribuinte =
            data.contribuinte == undefined ? "" : data.contribuinte.nome;
          const nomeLogradouro =
            data.logradouro == undefined ? "" : data.logradouro.nomeCompleto;

          console.log("estado", estado, "data", data);
          this.setState({
            ...estado,
            _uiNomeContribuinte: nomeContribuinte,
            _uiLogradouroNome: nomeLogradouro,
          });
        })
        .catch((error) => {
          if (error?.response?.data)
             ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    } else {
      _cadastroCorrente = Memoria.resturarEstado(
        this.props.location,
        _cadastroCorrente,
        _versaoCadastro
      );

      if (_cadastroCorrente == undefined) {
        _cadastroCorrente = { ...template };
      }

      _cadastroCorrente._uiSalvando = false;

      this.setState({ ..._cadastroCorrente, _uiCarregando: false });
    }

    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }
  showDadosInativacao() {
    this.state.usuarioIdQueInativou = UserInfo.getUsuarioId();

    return null;

    return (
      <GroupItem caption="Dados da Inativação" colSpan={3} colCount={3}>
        <SimpleItem
          dataField={"dataInativacao"}
          editorType={"dxDateBox"}
          editorOptions={{ width: "100%" }}
          colSpan={1}
        >
          <Label text="Data da Inativação" />
        </SimpleItem>
        <EmptyItem colSpan={2} />
        <SimpleItem
          dataField={"motivoInativacao"}
          editorType={"dxTextArea"}
          editorOptions={{ height: "200px" }}
          colSpan={3}
        >
          <Label text="Motivo da inativação" />
        </SimpleItem>
      </GroupItem>
    );
  }

  setCartDistrito(e) {
    this.setState({ distritoCartografia: e.value });
  }

  setCartSetor(e) {
    this.setState({ setorCartografia: e.value });
  }

  setCartQuadra(e) {
    this.setState({ quadraCartografia: e.value });
  }

  setCartFace(e) {
    this.setState({ faceCartografia: e.value });
  }

  setCartLote(e) {
    this.setState({ loteCartografia: e.value });
  }

  setCartUnidade(e) {
    this.setState({ unidadeCartografia: e.value });
  }

  renderCartografia() {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div style={{ width: "15%" }} className="dx-field-item-label-text">
            Dis
          </div>
          <div style={{ width: "15%" }} className="dx-field-item-label-text">
            Set
          </div>
          <div
            style={{ width: this.state.uiUsaFaceQuadra ? "20%" : "25%" }}
            className="dx-field-item-label-text"
          >
            Quadra
          </div>
          {this.state.uiUsaFaceQuadra ? (
            <div style={{ width: "15%" }} className="dx-field-item-label-text">
              Face
            </div>
          ) : null}
          <div style={{ width: "20%" }} className="dx-field-item-label-text">
            Lote
          </div>
          <div
            style={{ width: this.state.uiUsaFaceQuadra ? "15%" : "25%" }}
            className="dx-field-item-label-text"
          >
            Un.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NumberBox
            value={this.state.distritoCartografia}
            onValueChanged={this.setCartDistrito}
            width={"15%"}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
          />

          <NumberBox
            value={this.state.setorCartografia}
            onValueChanged={this.setCartSetor}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
            width={"15%"}
          />
          <NumberBox
            value={this.state.quadraCartografia}
            onValueChanged={this.setCartQuadra}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
            width={this.state.uiUsaFaceQuadra ? "20%" : "25%"}
          />
          {this.state.uiUsaFaceQuadra ? (
            <NumberBox
              value={this.state.faceCartografia}
              onValueChanged={this.setCartFace}
              format={uiInfo.formatoNumerico.inteiroSemPonto}
              width={"15%"}
            />
          ) : null}
          <NumberBox
            value={this.state.loteCartografia}
            onValueChanged={this.setCartLote}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
            width={"20%"}
          />
          <NumberBox
            value={this.state.unidadeCartografia}
            onValueChanged={this.setCartUnidade}
            width={this.state.uiUsaFaceQuadra ? "15%" : "25%"}
            format={uiInfo.formatoNumerico.inteiroSemPonto}
          />
        </div>
      </div>
    );
  }

  renderLabel(e) {
    const value = this.state[e.dataField];

    let valueStr = "";

    if (value !== undefined && value !== 0) {
      valueStr = value.toString().padStart(2, "0");
    }

    return <div className="dx-field-value-static">{valueStr}</div>;
  }

  render() {
    this.contribuinteDs = criarContribuinteDs();

    if (this.state._uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <LoadIndicator width={60} height={60} />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <ImovelButtonGroup props={{ ...this.props, ...this.state, _uiNatureza: this.state.natureza == 0 ? "P" : "T" }} />
          <form>
            <Form
              formData={this.state}
              colCount={3}
              labelLocation="top"
              ref={this.formImovel}
            >
              <GroupItem colSpan={3} colCount={10}>
                <GroupItem colCount={5} colSpan={4}>
                  <SimpleItem
                    dataField={"sequencial"}
                    colSpan={1}
                    render={this.renderLabel}
                  >
                    <Label text="Inscrição" />
                  </SimpleItem>

                  <SimpleItem
                    render={this.renderCartografia}
                    showTitle={false}
                    colSpan={4}
                  >
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>

                <EmptyItem colSpan={2} />

                <GroupItem colCount={10} colSpan={4}>
                  <SimpleItem dataField={"imovelAnteiorId"} colSpan={3}>
                    <Label text="Insc. Ant." />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"natureza"}
                    editorType="dxSelectBox"
                    editorOptions={this.naturezaOpcoes}
                    colSpan={4}
                  >
                    <Label text="Natureza" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"situacao"}
                    editorType="dxSelectBox"
                    editorOptions={this.situacaoOpcoes}
                    colSpan={3}
                  >
                    <Label text="Situação" />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>

              {this.state.Situacao === 2 ? this.showDadosInativacao() : []}

              <GroupItem caption="Responsável" colSpan={3} colCount={5}>
                <SimpleItem
                  dataField="contribuinteId"
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    showClearButton: true,
                    buttons: [
                      "clear",
                      {
                        name: "Pesquisar",
                        location: "after",
                        options: {
                          stylingMode: "text",
                          icon: "search",
                          onClick: () => {
                            this.setState({ exibirPesquisaContribuinte: true });
                          },
                        },
                      },
                    ],
                    onValueChanged: (e) => this.setContribuinteId(e.value),
                  }}
                  colSpan={1}
                >
                  <Label text="Cod. Contribuinte" />
                </SimpleItem>

                <SimpleItem
                  dataField={"_uiNomeContribuinte"}
                  colSpan={3}
                  editorOptions={{ readOnly: true, hoverStateEnabled: false }}
                >
                  <Label text="Nome" />
                </SimpleItem>

                <SimpleItem
                  dataField={"_uiDocumentoContribuinte"}
                  colSpan={1}
                  editorOptions={{ readOnly: true, hoverStateEnabled: false }}
                >
                  <Label text="CPF/CNPJ" />
                </SimpleItem>
              </GroupItem>



              <GroupItem caption="Dados do Imóvel" colSpan={3} colCount={5}>
                <SimpleItem
                  dataField={"cep"}
                  editorOptions={{ mask: "00000-000" }}
                >
                  <Label text="CEP" />
                </SimpleItem>

                <EmptyItem colSpan={4} />

                <SimpleItem
                  dataField="logradouroId"
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    showClearButton: true,
                    value:
                      this.state.logradouroId === undefined
                        ? null
                        : this.state.logradouroId,
                    buttons: [
                      "clear",
                      {
                        name: "Pesquisar",
                        location: "after",
                        options: {
                          stylingMode: "text",
                          icon: "search",
                          onClick: () => {
                            this.setState({ exibirPesquisaLogradouro: true });
                          },
                        },
                      },
                    ],
                    onValueChanged: (e) => this.onLogradouroChange(e),
                  }}
                  colSpan={1}
                >
                  <Label text="Cod. Logradouro" />
                </SimpleItem>
                <SimpleItem
                  dataField={"_uiLogradouroNome"}
                  colSpan={3}
                  editorOptions={{ readOnly: true, hoverStateEnabled: false }}
                >
                  <Label text="Logradouro" />
                </SimpleItem>

                <SimpleItem dataField={"numero"} colSpan={1}>
                  <Label text="Nº" />
                </SimpleItem>

                <SimpleItem dataField={"segmentoId"}>
                  <Label text="Segmento" />
                </SimpleItem>

                <SimpleItem dataField={"complemento"} colSpan={4}>
                  <Label text="Complemento" />
                </SimpleItem>

                <SimpleItem
                  dataField={"bairroId"}
                  editorType={"dxLookup"}
                  editorOptions={this.bairrosOptions}
                  colSpan={3}
                >
                  <Label text="Bairro" />
                </SimpleItem>

                <SimpleItem
                  dataField={"distritoId"}
                  editorType={"dxLookup"}
                  editorOptions={this.distritosOptions}
                  colSpan={2}
                >
                  <Label text="Distrito" />
                </SimpleItem>
              </GroupItem>

              <GroupItem colSpan={3} colCount={4}>
                <GroupItem caption="Loteamento">
                  <SimpleItem
                    dataField={"loteamentoId"}
                    editorType={"dxLookup"}
                    editorOptions={this.loteamentosOptions}
                  >
                    <Label text="Loteamento" />
                  </SimpleItem>

                  <SimpleItem dataField={"loteLoteamento"}>
                    <Label text="Lote" />
                  </SimpleItem>

                  <SimpleItem dataField={"quadraLoteamento"}>
                    <Label text="Quadra" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="Medida do Lote">
                  <SimpleItem
                    dataField={"larguraLote"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Largura" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"comprimentoLote"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Comprimento" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"areaLote"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Área" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem
                  caption="Medidas da Construção"
                  colCount={1}
                  colSpan={1}
                >
                  <SimpleItem
                    dataField={"larguraEdificacao"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Largura da Edificação" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"comprimentoEdificacao"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Comprimento da Edificação" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"areaEdificacao"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Área da Edificação" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="Outras Medidas" colCount={2} colSpan={1}>
                  <SimpleItem
                    dataField={"numeroPavimentos"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Nº de Pavimentos" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"numeroUnidades"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Nº de Unidades" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"numeroFrentes"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Nº de Frentes" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"areaPrivada"}
                    cssClass={"txtNumerico"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  >
                    <Label text="Área Privada" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"areaComum"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Área Comum" />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>

              <GroupItem caption="Classificação" colSpan={3} colCount={2}>
                <SimpleItem
                  dataField={"patrimonio"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.escolherTipoPatrimonio}
                >
                  <Label text="Patrimonio" />
                </SimpleItem>

                <SimpleItem
                  dataField={"posicaoPatrimonial"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.escolherPosicaoPatrimonial}
                >
                  <Label text="Posição Patrimonial" />
                </SimpleItem>

                <SimpleItem
                  dataField={"uso"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.escolherUsoImovel}
                >
                  <Label text="Uso do Imóvel" />
                </SimpleItem>

                <SimpleItem
                  dataField={"posicaoFiscalIptu"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.escolherPosicaoFiscal}
                >
                  <Label text="Posição Fiscal IPTU" />
                </SimpleItem>

                <SimpleItem
                  dataField={"posicaoFiscalTsu"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.escolherPosicaoFiscal}
                >
                  <Label text="Posição Fiscal TSU" />
                </SimpleItem>
              </GroupItem>

              <GroupItem colSpan={3} colCount={2}>
                <GroupItem caption="Coordenadas">
                  <SimpleItem
                    dataField={"coordenadaX"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: "0.00000000" }}
                  >
                    <Label text="Coordenada X" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"coordenadaY"}
                    editorType={"dxNumberBox"}
                    editorOptions={{ format: "##0.00000000" }}
                  >
                    <Label text="Coordenada Y" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem caption="Cômodos" colCount={2}>
                  <SimpleItem
                    dataField={"quartos"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Qtde. Quartos" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"salas"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Qtde. Salas" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"cozinhas"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Qtde. Cozinhas" />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"wc"}
                    editorType={"dxNumberBox"}
                    editorOptions={{
                      format: uiInfo.formatoNumerico.inteiroSemPonto,
                    }}
                    cssClass={"txtNumerico"}
                  >
                    <Label text="Qtde. Banheiros" />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>

              <GroupItem caption="Outras Informações" colSpan={3} colCount={4}>
                <SimpleItem
                  dataField={"afastamentoFrontal"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Afastamento Frontal" />
                </SimpleItem>

                <SimpleItem
                  dataField={"larguraPasseio"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Medida do Passeio" />
                </SimpleItem>
                <SimpleItem
                  dataField={"qtdeArvoresPasseio"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.inteiroSemPonto,
                  }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Árvores no Passeio" />
                </SimpleItem>

                <SimpleItem
                  dataField={"anoConstrucao"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.inteiroSemPonto,
                  }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Ano Construção" />
                </SimpleItem>

                <SimpleItem
                  dataField={"setorCensitario"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ showClearButton: true }}
                >
                  <Label text="Setor Censitário" />
                </SimpleItem>

                <SimpleItem
                  dataField={"qtdePontosDeAgua"}
                  editorType={"dxNumberBox"}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Qtde. Pontos de Água" />
                </SimpleItem>

                <SimpleItem dataField={"inscricaoCAA"}>
                  <Label text="Inscrição C.A.A." />
                </SimpleItem>

                <SimpleItem dataField={"inscricaoCAE"}>
                  <Label text="Inscrição C.A.E." />
                </SimpleItem>

                <SimpleItem
                  dataField={"SituacaoProcessoJudicial"}
                  colSpan={1}
                  editorType={"dxSelectBox"}
                  editorOptions={this.escolherSituacaoProcessoJudicial}
                >
                  <Label text="Situação do Processo Judicial" />
                </SimpleItem>

                <SimpleItem
                  dataField={"dataProcesso"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%" }}
                >
                  <Label text="Data do Processo" />
                </SimpleItem>

                <SimpleItem dataField={"processo"} colSpan={2}>
                  <Label text="Processo" />
                </SimpleItem>

                <SimpleItem dataField={"matricula"}>
                  <Label text="Mat. Cartório" />
                </SimpleItem>

                <SimpleItem
                  dataField={"cartorioId"}
                  editorType={"dxLookup"}
                  editorOptions={this.cpbsOptions}
                  colSpan={3}
                >
                  <Label text="Cartório" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="Outras Testadas" colCount={5} colSpan={3}>
                <SimpleItem
                  dataField={"testada2"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Testada 2" />
                </SimpleItem>

                <SimpleItem
                  dataField={"logradouroTestada2Id"}
                  editorType={"dxLookup"}
                  editorOptions={this.logradourosOptions}
                  colSpan={4}
                >
                  <Label text="Logradouro" />
                </SimpleItem>

                <SimpleItem
                  dataField={"testada3"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Format type="fixedPoint" precision={"2"} />
                  <Label text="Testada 3" />
                </SimpleItem>
                <SimpleItem
                  dataField={"logradouroTestada3Id"}
                  editorType={"dxLookup"}
                  editorOptions={this.logradourosOptions}
                  colSpan={4}
                >
                  <Label text="Logradouro" />
                </SimpleItem>

                <SimpleItem
                  dataField={"testada4"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Testada 4" />
                </SimpleItem>
                <SimpleItem
                  dataField={"logradouroTestada4Id"}
                  editorType={"dxLookup"}
                  editorOptions={this.logradourosOptions}
                  colSpan={4}
                >
                  <Label text="Logradouro" />
                </SimpleItem>
              </GroupItem>

              <GroupItem colSpan={3} colCount={1}>
                <SimpleItem
                  dataField={"observacao"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "200px" }}
                >
                  <Label text="Observações" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="Atualizar Dívida Ativa e IPTU do Exercício" colSpan={3} colCount={3} visible={this.state._uiContribuinteIdOriginal != undefined && this.state.contribuinteId !== this.state._uiContribuinteIdOriginal}>
                <SimpleItem
                  dataField="atualizarIptuExercicio"
                  editorType={"dxSelectBox"}
                  editorOptions={this.simNaoOptions}
                >
                  <Label text="Atualizar IPTU" />
                </SimpleItem>

                <SimpleItem
                  dataField="atualizarDiatImovel"
                  editorType={"dxSelectBox"}
                  editorOptions={this.simNaoOptions}
                >
                  <Label text="Atualizar DIAT" />
                </SimpleItem>

                <SimpleItem
                  dataField={"exercicioDiatInicial"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}
                  cssClass={"txtNumerico"}
                  helpText={"Deixe 0 (zero) para todas as dívidas."}
                >
                  <Label text="Exercício Inicial DIAT" />
                </SimpleItem>


              </GroupItem>
            </Form>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                  disabled={this.state.loadIndicatorVisivel}
                >
                  <LoadIndicator
                    className="button-indicator"
                    id="small-indicator"
                    height={20}
                    width={20}
                    visible={this.state.loadIndicatorVisivel}
                    style={{ marginRight: "10px", verticalAlign: "middle" }}
                  />
                  <span className="dx-button-text">
                    {this.state.textoBotao}
                  </span>
                </Button>
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  disabled={this.state.loadIndicatorVisivel}
                  text="Cancelar"
                  width={120}
                  onClick={this.cancel}
                />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.exibirPesquisaContribuinte}
            onHiding={() =>
              this.setState({ exibirPesquisaContribuinte: false })
            }
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"onScroll"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () =>
                  this.setState({ exibirPesquisaContribuinte: false }),
              }}
            ></ToolbarItem>
          </Popup>

          <Popup
            visible={this.state.exibirPesquisaLogradouro}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Logradouro"
          >
            <ScrollView showScrollbar={"onScroll"}>
              <LogradourosBox
                onSelecionado={this.onLogradouroSelecionadoPesq}
                ref={this.logradourosBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () =>
                  this.setState({ exibirPesquisaLogradouro: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state._uiConfirmarDiatEIptu}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"600"}
            height={"350"}
            title="Realmente confirma essas mudanças?"
          >
            <div style={{ padding: 5, marginTop: -20 }}>

              {this.state.atualizarIptuExercicio &&
                <h3 style={{ textAlign: "justify", color: "red" }}>
                  Você realmente deseja transferir IPTU deste imóvel e exercício para o novo contribuinte do cadastro?
                </h3>
              }

              {this.state.atualizarDiatImovel &&
                <h3 style={{ textAlign: "justify", color: "red" }}>
                  {this.state._uiMsgDiat}
                </h3>
              }
            </div>


            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="after"
              options={{
                text: "Sim",
                type: "success",
                width: 150,
                onClick: this.okConfirmar
              }}
            />
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="after"
              options={{
                text: "Não",
                width: 150,
                onClick: () => this.setState({ _uiConfirmarDiatEIptu: false })
              }}
            />
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  onValueChanged(e) {
    this.setState({
      inativo: e.value,
    });
  }


  okConfirmar() {
    this.setState(
      {
        loadIndicatorVisivel: true,
        textoBotao: "Salvando...",
      },
      async () => {
        const entidade = {
          ...this.state,
          prefeituraId: UserInfo.getPrefeitura(),
        };

        if (entidade._uiContribuinteIdOriginal != undefined && entidade._uiContribuinteIdOriginal == entidade.contribuinteId) {
          entidade.atualizarDiatImovel = false;
          entidade.atualizarIptuExercicio = false;
        }

        if (entidade.id != undefined && this.props.match.id != undefined) {
          if (entidade.id != this.props.match.id) {
          }
        }

        this.setState({ _uiSalvando: true });

        await axiosApi
          .post("imoveis/geral", entidade)
          .then((response) => {
            notify("Imóvel editado com sucesso.", "success");
            _cadastroCorrente = undefined;
            _cancelando = true;
            Memoria.removerEdicao(this.props.location);

            if (entidade.id == 0 || entidade.id == undefined) {
              this.props.history.push("/imoveis/editar/" + response.data.id);
            } else {
              _cadastroCorrente = undefined;
              _cancelando = true;
              Memoria.removerEdicao(this.props.location);
              this.props.history.push("/imoveis");
            }
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              ShowError(error.response.data.erros);
            } else {
              ShowError(error.message);
            }
          })
          .finally(() => {
            this.setState({ _uiSalvando: false });
          });
        this.setState({ loadIndicatorVisivel: false, textoBotao: "Salvar" });
      }
    );
  }

  ok() {

    const contribuinteAlterado = this.state._uiContribuinteIdOriginal != this.state.contribuinteId;
    const solitouAlterarDiatIptu = this.state.atualizarDiatImovel || this.state.atualizarIptuExercicio;
    let msgDiat = "";

    if (this.state.exercicioDiatInicial == 0) {
      msgDiat = "Você realmente deseja transferir todas as dívidas pendentes do imóvel para o novo contribuinte do cadastro?";
    }
    else {
      msgDiat = `Você realmente deseja transferir as dívidas do imóvel do exercício ${this.state.exercicioDiatInicial}, e posteriores, para o novo contribuinte do cadastro?`;
    }

    if (contribuinteAlterado && solitouAlterarDiatIptu) {
      this.setState({ _uiConfirmarDiatEIptu: true, _uiMsgDiat: msgDiat });
      return;
    }

    this.okConfirmar();
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    Memoria.removerEdicao(this.props.location);
    this.props.history.push("/imoveis");
  }
}
